document.addEventListener('DOMContentLoaded', function() {
  var menuSection = document.querySelector('.menu-section');
  var menuLinks = document.querySelectorAll('.menu-link');
  var closeButton = document.querySelector('.close-button');

  // Page-specific elements
  var logoContainer = document.querySelector('.logo-container');
  var galleryContainer = document.querySelector('.adaptive-gallery-wrapper');
  var imageContainer = document.querySelector('.image-container');
  var textSection = document.querySelector('.text-section');

  // Function to show the nested menu and hide the parent menu
  function showNestedMenu(event) {
    event.preventDefault();

    var parentMenuItem = event.currentTarget.parentNode;
    var nestedMenu = parentMenuItem.querySelector('.nested-menu');

    nestedMenu.style.display = 'block';
    nestedMenu.style.opacity
    setTimeout(function() {
      nestedMenu.style.opacity = 1;
    }, 2);

    menuLinks.forEach(function(link) {
      link.style.display = 'none';
      link.style.opacity = 0;
    });

    if (logoContainer) {
      logoContainer.style.transform = 'translateX(25%)';
      logoContainer.classList.add('hidden-logo');
 
    }
    if (galleryContainer) {
      galleryContainer.style.transform = 'translateX(50%)';
      galleryContainer.classList.add('hidden-gallery');
     
    }
    if (imageContainer) {
      imageContainer.style.transform = 'translateX(25%)';
      imageContainer.classList.add('hidden-image');
  
    }
    if (textSection) {
      textSection.style.visibility = "hidden";
      textSection.style.opacity = 0;
    }

    closeButton.style.display = 'block';
    setTimeout(function() {
      closeButton.style.opacity = 1;
    }, 2);
  }

  // Attach event listeners to menu items that have a nested menu
  document.querySelectorAll('.menu-item.has-nested-menu > .menu-link').forEach(function(menuItem) {
    menuItem.addEventListener('click', showNestedMenu);
  });

  // Event listener for the close button
  closeButton.addEventListener('click', function() {
    document.querySelectorAll('.nested-menu').forEach(function(menu) {
      menu.style.opacity = 0;
      menu.style.display = 'none';
    });

    if (logoContainer) {
      logoContainer.style.transform = 'translateX(0)';
      logoContainer.classList.remove('hidden-logo');

    }
    if (galleryContainer) {
      galleryContainer.style.transform = 'translateX(0)';
      galleryContainer.classList.remove('hidden-gallery');

    }
    if (imageContainer) {
      imageContainer.style.transform = 'translateX(0)';
      imageContainer.classList.remove('hidden-image');
 
    }
    if (textSection) {
      textSection.style.visibility = "visible";
      setTimeout(function() {
        textSection.style.opacity = 1;
      }, 2);
    }

    menuLinks.forEach(function(link) {
      link.style.display = 'block';
      setTimeout(function() {
        link.style.opacity = 1;
      }, 2);
    });

    closeButton.style.display = 'none';
    closeButton.style.opacity = 0;
   
    
  });

  // Close nested menus when clicking outside
  document.addEventListener('click', function(event) {
    if (!event.target.closest('.nested-menu') && !event.target.closest('.menu-link')) {
      document.querySelectorAll('.nested-menu').forEach(function(menu) {
        menu.style.opacity = 0;
        menu.style.display = 'none';
        
      });


      if (logoContainer) {
          logoContainer.style.transform = 'translateX(0)';
          logoContainer.classList.remove('hidden-logo');

      }
      if (galleryContainer) {
          galleryContainer.classList.remove('hidden-gallery');
          galleryContainer.style.transform = 'translateX(0)';
         
      }
      if (imageContainer) {
        imageContainer.style.transform = 'translateX(0)';
        imageContainer.classList.remove('hidden-image');
      }
      if (textSection) {
        textSection.style.visibility = "visible";
        setTimeout(function() {
          textSection.style.opacity = 1;
        }, 2);
      }

       menuLinks.forEach(function(link) {
        link.style.display = 'block';
        setTimeout(function() {
          link.style.opacity = 1;
        }, 2);
      });

      closeButton.style.display = 'none';
      closeButton.style.opacity = 0;


      
    }
  });
});
